import { normalize } from 'polished';
import { createGlobalStyle } from 'theme';

export const Normalized = createGlobalStyle`
  ${normalize()}
`;
